import {Outlet} from '@github-ui/react-router'
import {LayoutComponent} from '../App'
import {pullRequestsLayoutRoute} from './layout-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useGitDataLiveUpdates} from '../hooks/use-git-data-live-updates'

export function LayoutEntrypoint() {
  const {
    data: {pullRequest, bannersData, repository, urls, user, aliveChannel},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')

  useGitDataLiveUpdates(aliveChannel)

  return (
    <LayoutComponent
      aliveChannel={aliveChannel}
      pullRequest={pullRequest}
      bannersData={bannersData}
      repository={repository}
      urls={urls}
      user={user}
    >
      <Outlet />
    </LayoutComponent>
  )
}

try{ LayoutEntrypoint.displayName ||= 'LayoutEntrypoint' } catch {}